import { useEffect, useRef } from "react";

function isTyping(el: EventTarget | null) {
  const node = el as HTMLElement | null;
  return Boolean(node && (node.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(node.tagName)));
}

/** Page-level single-key shortcut, ignored while typing or when a dialog is open. */
export function useHotkey(key: string, handler: (e: KeyboardEvent) => void, enabled = true) {
  const ref = useRef(handler);
  useEffect(() => {
    ref.current = handler;
  });
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.defaultPrevented || e.key !== key || e.metaKey || e.ctrlKey || e.altKey || isTyping(e.target)) return;
      if (document.querySelector("[role=dialog]")) return;
      ref.current(e);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [key, enabled]);
}
